module.exports = __webpack_public_path__ + "img/pool-and-bio-pool.3b4f5e86.svg";